module.exports = __webpack_public_path__ + "img/newLogo3.e9774527.png";